import { Routes, Route, useLocation } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import NavBar from './components/NavBar';
import TopBar from './components/TopBar';
import PageSkeleton from './components/PageSkeleton';

const CollectionPage = lazy(() => import('./pages/Collection'));
const AddPage = lazy(() => import('./pages/Add'));
const CameraPage = lazy(() => import('./pages/Camera'));
const ResultPage = lazy(() => import('./pages/Result'));
const MePage = lazy(() => import('./pages/Me'));
const ItemDetailPage = lazy(() => import('./pages/ItemDetail'));

export default function App() {
  const location = useLocation();
  const isCamera = location.pathname.startsWith('/camera');

  return (
    <div className="min-h-screen flex flex-col" style={{ paddingTop: 'var(--safe-top)' }}>
      {!isCamera && <TopBar />}
      <main className="flex-1 pb-28">
        <Suspense fallback={<PageSkeleton />}>
          <Routes>
            <Route path="/" element={<CollectionPage />} />
            <Route path="/add" element={<AddPage />} />
            <Route path="/camera" element={<CameraPage />} />
            <Route path="/result" element={<ResultPage />} />
            <Route path="/me" element={<MePage />} />
            <Route path="/item/:id" element={<ItemDetailPage />} />
            <Route path="*" element={<CollectionPage />} />
          </Routes>
        </Suspense>
      </main>
      {!isCamera && <NavBar />}
    </div>
  );
}
